import Header from "glesys-controlpanel/components/entity/header";
import Fields from "glesys-controlpanel/components/entity/fields";
import Menu, { MenuAnchor } from "glesys-controlpanel/components/entity/menu";
import mergeClasses from "glesys-controlpanel/modifiers/merge-classes";

<template>
  <div
    class="relative [anchor-scope:all] border border-gray-200 bg-white rounded-sm text-base"
    {{mergeClasses}}
    ...attributes
  >
    <Header @title={{@title}} @key={{@key}} @workflowState={{@workflowState}} @managedHosting={{@managedHosting}}>
      {{#if @hasActions}}
        <MenuAnchor />
      {{/if}}
    </Header>
    {{#if @hasActions}}
      <Menu class="right-4 sm:right-6" @title={{@title}}>
        {{yield to="actions"}}
      </Menu>
    {{/if}}
    {{#if @hasFields}}
      <Fields @status={{@status}}>
        {{yield to="fields"}}
      </Fields>
    {{/if}}
  </div>
</template>
